<template>
  <el-select
    ref="select"
    v-model="selectValue"
    :multiple="multiple"
    :filter-method="dataFilter"
    @remove-tag="removeTag"
    @clear="clearAll"
    popper-class="t-tree-select"
    :style="{ width: width || '100%' }"
    v-bind="attrs"
    v-on="$listeners"
  >
    <el-option v-model="selectTree" class="option-style" disabled>
      <div class="check-box" v-if="multiple && checkBoxBtn">
        <el-button type="text" @click="handlecheckAll">{{
          checkAllText
        }}</el-button>
        <el-button type="text" @click="handleReset">{{ resetText }}</el-button>
        <el-button type="text" @click="handleReverseCheck">{{
          reverseCheckText
        }}</el-button>
      </div>
      <el-tree
        :data="options"
        :props="treeProps"
        class="tree-style"
        ref="treeNode"
        :expand-on-click-node="expandOnClick"
        :show-checkbox="multiple"
        :node-key="treeProps.value"
        :filter-node-method="filterNode"
        :default-checked-keys="defaultValue"
        :current-node-key="currentKey"
        @node-click="handleTreeClick"
        @check-change="handleNodeChange"
        v-bind="treeAttrs"
        v-on="$listeners"
      ></el-tree>
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: "SelectTree",
  props: {
    defaultValue: {
      type: Array,
      default: () => [],
    },
    defaultData: {
      type: Object,
    },
    checkAllText: {
      type: String,
      default: "全选",
    },
    resetText: {
      type: String,
      default: "清空",
    },
    reverseCheckText: {
      type: String,
      default: "反选",
    },
    options: {
      type: Array,
      default: () => [],
    },
    treeProps: {
      type: Object,
      default: () => ({
        value: "value",
        label: "label",
        children: "children",
      }),
    },
    checkBoxBtn: {
      type: Boolean,
      default: true,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
    },
    expandOnClick: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      selectTree: this.multiple ? [] : "",
      selectValue: this.multiple ? [] : "",
      currentKey: null,
      filterText: null,
      VALUE_NAME: this.treeProps.value,
      VALUE_TEXT: this.treeProps.label,
    };
  },
  computed: {
    attrs() {
      return {
        "popper-append-to-body": false,
        clearable: true,
        filterable: true,
        ...this.$attrs,
      };
    },
    treeAttrs() {
      return {
        "default-expand-all": true,
        ...this.$attrs,
      };
    },
  },
  watch: {
    defaultValue: {
      handler() {
        this.$nextTick(() => {
          if (this.multiple) {
            let datalist = this.$refs.treeNode.getCheckedNodes();
            this.selectTree = datalist;
            this.selectValue = datalist.map((v) => v[this.VALUE_TEXT]);
          }
        });
      },
      deep: true,
    },
    filterText(val) {
      this.$refs.treeNode.filter(val);
    },
  },
  mounted() {
    if (this.multiple) {
      let datalist = this.$refs.treeNode.getCheckedNodes();
      this.selectTree = datalist;
      this.selectValue = datalist.map((v) => v[this.VALUE_TEXT]);
    }
    if (this.defaultData && this.defaultData.id) {
      this.setDefaultValue(this.defaultData);
    }
  },
  watch: {
    defaultData(newVal, oldVal) {
      this.setDefaultValue(newVal);
    },
  },
  methods: {
    setDefaultValue(obj) {
      if (obj.label !== "" && obj.id !== "") {
        this.selectTree = obj.id;
        this.selectValue = obj.label;
        this.$nextTick(() => {
          this.currentKey = this.selectTree;
          this.setTreeChecked(this.selectTree);
        });
      }
    },
    handlecheckAll() {
      setTimeout(() => {
        this.$refs.treeNode.setCheckedNodes(this.options);
      }, 200);
    },
    handleReset() {
      setTimeout(() => {
        this.$refs.treeNode.setCheckedNodes([]);
      }, 200);
    },

    batchSelect(nodes, refs, flag, seleteds) {
      if (Array.isArray(nodes)) {
        nodes.forEach((element) => {
          refs.setChecked(element, flag, true);
        });
      }
      if (Array.isArray(seleteds)) {
        seleteds.forEach((node) => {
          refs.setChecked(node, !flag, true);
        });
      }
    },
    handleReverseCheck() {
      setTimeout(() => {
        let res = this.$refs.treeNode;
        let nodes = res.getCheckedNodes(true, true);
        this.batchSelect(this.options, res, true, nodes);
      }, 200);
    },
    dataFilter(val) {
      setTimeout(() => {
        this.filterText = val;
      }, 100);
    },
    filterNode(value, data) {
      if (!value) return true;
      return (
        data[this.treeProps.label]
          .toLowerCase()
          .indexOf(value.toLowerCase()) !== -1
      );
    },
    handleNodeChange(data, self, child) {
      let datalist = this.$refs.treeNode.getCheckedNodes();
      this.$nextTick(() => {
        this.selectTree = datalist;
        this.selectValue = datalist.map((v) => {
          console.log(777, v[this.VALUE_TEXT]);
          return v[this.VALUE_TEXT];
        });
        this.$emit("handleNodeClick", this.selectTree);
      });
    },
    handleTreeClick(data, node) {
      if (this.multiple) {
      } else {
        this.filterText = "";
        this.selectTree = data[this.VALUE_NAME];
        this.selectValue = data[this.VALUE_TEXT];
        this.currentKey = this.selectTree;
        this.highlightNode = data[this.VALUE_NAME];
        this.$emit(
          "handleNodeClick",
          { id: this.selectTree, label: this.selectValue },
          node
        );
        this.setTreeChecked(this.highlightNode);
        this.$refs.select.blur();
      }
    },
    setTreeChecked(highlightNode) {
      if (this.treeAttrs.hasOwnProperty("show-checkbox")) {
        this.$refs.treeNode.setCheckedKeys([highlightNode]);
      } else {
        this.$refs.treeNode.setCurrentKey(highlightNode);
      }
    },
    removeTag(tagName) {
      this.selectTree = this.selectTree.filter(
        (v) => v[this.VALUE_TEXT] !== tagName
      );
      const selectTreeValue = this.selectTree.map((v) => v[this.VALUE_NAME]);
      let setlist = this.$refs.treeNode.getCheckedNodes();
      setlist = setlist.filter(
        (v) =>
          v[this.VALUE_NAME] ===
          selectTreeValue.find((item) => item === v[this.VALUE_NAME])
      );
      this.$nextTick(() => {
        this.$refs.treeNode.setCheckedNodes(setlist);
      });
      this.$emit("handleNodeClick", this.selectTree);
    },
    clearAll() {
      this.selectTree = this.multiple ? [] : "";
      this.$refs.treeNode.setCheckedNodes([]);
      this.$emit("handleNodeClick", this.selectTree);
    },
  },
};
</script>

<style scoped>
.t-tree-select .check-box {
  padding: 0 20px;
}
.t-tree-select .option-style {
  height: 100%;
  max-height: 300px;
  margin: 0;
  overflow-y: auto;
  cursor: default !important;
}
.t-tree-select
  .tree-style
  ::v-deep
  .el-tree-node.is-current
  > .el-tree-node__content {
  color: #3370ff;
}
.t-tree-select .el-select-dropdown__item.selected {
  font-weight: 500;
}
.t-tree-select .el-input__inner {
  height: 36px;
  line-height: 36px;
}
.t-tree-select .el-input__icon {
  line-height: 36px;
}
.t-tree-select .el-tree-node__content {
  height: 32px;
}
</style>
